import { regionData, RegionKey, RegionLink } from './prefooterData';

export function determineRegionSlug(
	pathListaSeo: string[],
): RegionLink[] | null {
	let regionSlug: RegionKey | undefined;

	const tienePropiedad = pathListaSeo.some(
		(path) => path.includes('departamento') || path.includes('casa'),
	);

	if (!tienePropiedad) {
		return null;
	}

	if (pathListaSeo.includes('metropolitana')) {
		regionSlug = 'metropolitana';
	} else if (pathListaSeo.includes('valparaiso')) {
		regionSlug = 'valparaiso';
	} else if (pathListaSeo.includes('biobio')) {
		regionSlug = 'biobio';
	}

	return regionSlug ? regionData[regionSlug] : null;
}

export function determineRegionSlugWithUrl(regionSlug: string,
): RegionLink[] | null {
	const regionKey = regionSlug.toLowerCase() as RegionKey;
	return regionKey ? regionData[regionKey] : null;
}